(function(root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.PocketPersonalizationCore = api;
})(typeof window !== 'undefined' ? window : this, function() {
  'use strict';
  const key = 'pf.personalization.v1';
  function normalizeBusinessUrl(input) {
    if (typeof input !== 'string' || !input.trim() || input.length > 2048) throw new Error('Invalid website');
    const raw = input.trim();
    if (/[\\\s]/.test(raw)) throw new Error('Invalid website');
    const url = new URL(/^[a-z][a-z\d+.-]*:/i.test(raw) ? raw : 'https://' + raw);
    const domain = url.hostname.replace(/^www\./, '');
    if (!['https:', 'http:'].includes(url.protocol) || url.username || url.password || url.port || domain.length > 253 || !domain.includes('.') || !domain.split('.').every(p => /^[a-z\d](?:[a-z\d-]{0,61}[a-z\d])?$/i.test(p)) || /^\d+(\.\d+){3}$/.test(domain)) throw new Error('Invalid website');
    return 'https://' + domain;
  }
  async function resolveBusiness(input) {
    const domain = new URL(normalizeBusinessUrl(input)).hostname;
    const name = domain.split('.')[0].replace(/-/g, ' ').replace(/(plumbing|salon|studio|dental|services)$/i, ' $1').trim().replace(/\s+/g,' ');
    return {domain, businessName:name.replace(/\b\w/g, c=>c.toUpperCase()).slice(0,80), logoUrl:null, logoType:'monogram', logoConfidence:0, primaryColor:'#d4f54a', source:'mock'};
  }
  function validateBrand(b) {
    if(b && ['tinyfish','fixture','manual'].includes(b.source)) {
      const service=typeof module==='object'&&module.exports?require('./pocket-brand-service.js'):window.PocketBrandService;
      return service.normalizeBrand(b);
    }
    if (!b || typeof b.domain !== 'string' || normalizeBusinessUrl(b.domain) !== 'https://' + b.domain || typeof b.businessName !== 'string' || !b.businessName.trim() || b.businessName.length > 80 || /[\x00-\x1f]/.test(b.businessName) || b.source !== 'mock' || b.logoUrl !== null || b.logoType !== 'monogram' || b.logoConfidence !== 0 || !/^#[a-f\d]{6}$/i.test(b.primaryColor)) throw new Error('Invalid preview');
    return {domain:b.domain,businessName:b.businessName,logoUrl:null,logoType:b.logoType,logoConfidence:0,primaryColor:b.primaryColor,source:b.source};
  }
  function createBrandStore(storage) {
    let state = {brand:null, dismissed:false};
    const listeners = new Set();
    try {
      const saved = JSON.parse(storage?.getItem(key) || 'null');
      if(saved?.version === 1 && typeof saved.dismissed === 'boolean') state = {brand:saved.brand ? validateBrand(saved.brand) : null,dismissed:saved.dismissed};
    } catch (_) {}
    const getState = () => ({brand:state.brand ? {...state.brand}:null,dismissed:state.dismissed});
    function update(next) {
      state = next;
      try { storage?.setItem(key, JSON.stringify({version:1,...state})); } catch (_) {}
      listeners.forEach(fn=>fn(getState()));
    }
    return {getState,setBrand(brand){update({brand:validateBrand(brand),dismissed:true});},dismiss(){update({...state,dismissed:true});},reset(){update({brand:null,dismissed:true});},subscribe(fn){listeners.add(fn);return ()=>listeners.delete(fn);}};
  }
  return {normalizeBusinessUrl,resolveBusiness,createBrandStore};
});
